import { render, staticRenderFns } from "./pasta-parallax-wrapper-cmp.vue?vue&type=template&id=60b7d682&scoped=true"
import script from "./pasta-parallax-wrapper-cmp.vue?vue&type=script&lang=js"
export * from "./pasta-parallax-wrapper-cmp.vue?vue&type=script&lang=js"
import style0 from "./pasta-parallax-wrapper-cmp.vue?vue&type=style&index=0&id=60b7d682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b7d682",
  null
  
)

export default component.exports